import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ExpenseItemCreatePage } from './expense-item-create';

@NgModule({
  declarations: [
    ExpenseItemCreatePage,
  ],
  imports: [
    IonicPageModule.forChild(ExpenseItemCreatePage),
  ],
})
export class ExpenseItemCreatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/expense-item-create/expense-item-create.module.ts